// AsyncLocalStorage is Node-only. A static import is pulled into the client
// graph through authOptions, and Turbopack then fails the build.
// The require runs only on the server.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let storage: any = null;

function getStorage() {
  if (!storage && typeof window === 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { AsyncLocalStorage } = require('async_hooks');
    storage = new AsyncLocalStorage();
  }
  return storage;
}

export function shouldSkipKeycloakLogout(): boolean {
  return getStorage()?.getStore() === true;
}

export function runWithSkipKeycloakLogout<T>(skip: boolean, run: () => T): T {
  const current = getStorage();
  if (!current) return run();
  return current.run(skip, run);
}
